import { render } from "./force-phone-modal.vue?vue&type=template&id=124e6410"
import script from "./force-phone-modal.vue?vue&type=script&lang=js"
export * from "./force-phone-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__